import { StepOutputParameter } from '../../app/core/models/parameter.model';
import { Workflow } from '../../app/core/models/workflow.model';
import { Step } from '../../app/core/models/step.model';

export function getParameterEndpointId(type: 'input' | 'output', flowId: string, parameterKey: string): string {
    return 'module_' + flowId + '_' + type + '_' + parameterKey;
}

export function getOutputTypes(step: Step, workflow: Workflow | null): string[] {
    const res: string[] = [];
    if (!workflow) {
        return res;
    }

    for (const wStep of workflow.steps) {
        if (step.flowId !== wStep.flowId) {
            for (const parameter of wStep.inputParameters) {
                if (parameter instanceof StepOutputParameter) {
                    const sourceStep = workflow.getStep(parameter.sourceFlowId)!;
                    if (sourceStep.flowId === step.flowId) {
                        res.push(parameter.type);
                    }
                }
            }
        }
    }

    return res;
}

export function increaseIndex(maxNumber: number, index?: number): number {
    if (index == null) {
        return 0;
    }

    if (index >= maxNumber - 1) {
        return index;
    }

    return index + 1;
}

export function decreaseIndex(currentIndex?: number): number {
    if (currentIndex != null && currentIndex > 0) {
        return currentIndex - 1;
    }

    return 0;
}
